import { DiToken, provideDiTokenValue, registerDiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

export interface PwaDeviceContext {
  isMobile(): boolean;
  isPWA(): boolean;
  isIosDevice(): boolean;
  isSafari(): boolean;
}

// biome-ignore lint/style/useNamingConvention: must be that way
export const PWA_DEVICE_CONTEXT: DiToken<PwaDeviceContext> = new DiToken<PwaDeviceContext>('pwaDeviceContext');

export function registerPwaDeviceContext(context: PwaDeviceContext): void {
  registerDiToken(PWA_DEVICE_CONTEXT, () => context);
}

export function providePwaDeviceContext(): PwaDeviceContext {
  return provideDiTokenValue(PWA_DEVICE_CONTEXT);
}
